import React from 'react';
import { LettingWidgetBase } from '../LettingWidgetBase/LettingWidgetBase';
import styles from '../Widgets.module.scss';
export const LettingTypeWidget = ({ onClick, type, label }) => {
    return (<LettingWidgetBase iconUrl='https://www.haven.com/assets/owners/lettings/calendar-edit.svg' title='Letting with Haven' isClosed={false} onClick={onClick} subtitle='Letting type'>
      <p>{type}</p>
      {!!label && <span className={styles.label}>{label}</span>}
    </LettingWidgetBase>);
};
